import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyInvoice = {
  // 获取组织机构列表
  getFormTreeList(params) {
    return http.post(`${baseUrl}Org/formTree`, params)
  },
  // 获取公司发票抬头
  getInvoiceRiseList(params) {
    return http.post(`${baseUrl}Company/getInvoiceRise`, params)
  },
  // 获取机票发票
  getPlaneInvoiceList(params) {
    return http.post(`${baseUrl}Company/planeOrderReport`, params)
  },
  // 获取火车票票发票
  getTrainInvoiceList(params) {
    return http.post(`${baseUrl}Company/trainOrderReport`, params)
  },
  // 获取酒店发票
  getHotelInvoiceList(params) {
    return http.post(`${baseUrl}Company/hotelOrderReport`, params)
  },
  // 获取用车发票
  getCarInvoiceList(params) {
    return http.post(`${baseUrl}Company/carOrderReport`, params)
  },
  // 获取已开发票列表
  getInvoiceList(params) {
    return http.post(`${baseUrl}Company/invoiceList`, params)
  },
  // 获取已开发票详情表格
  invoiceWithNo(params) {
    return http.post(`${baseUrl}Company/invoiceWithNo`, params)
  },
  // 申请发票
  addInvoice(params) {
    return http.post(`${baseUrl}Company/addInvoice`, params)
  },

}



// WEBPACK FOOTER //
// ./src/api/companyInvoice.js